module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/0.25-b9167edeacca406f13c5322acd0c5b8d.svg";